module.exports = __webpack_public_path__ + "img/70.151b58a6.jpg";